import { Switch } from "@mui/material"
import Select from "react-dropdown-select"
import { RecommendationArgumentDropdownValues, RecommendationDropdownValues, metaCategories, EdgynComfortOptions, AiImageQualityValues } from "../../constants"

const AdditionalDataUpdate = ({ userLoggedIn, category, type = 'social', imageData, seasonalcategoryMetadata, updateSeasonalCategoryfield, values, }) => {

  return <>
    {userLoggedIn.curator && category ? <div>
      <a className="primary-btn w-full"
        href={`https://lens.google.com/uploadbyurl?url=${imageData.imageUrl}`}
        target='_blank'
      >Search image</a>
      {seasonalcategoryMetadata ? <div className={`w-full px-4 ${seasonalcategoryMetadata.hidden ? 'text-red-600 font-normal' : 'font-semibold'}`}>
        <span>Hidden</span>
        <Switch
          checked={seasonalcategoryMetadata.hidden != true}
          onChange={next => {
            updateSeasonalCategoryfield('hidden', !next.target.checked)
          }}
        />
        <span>Visible</span>

      </div> : null}
      <div className="w-96 px-4">
        Season dropdown : <Select values={seasonalcategoryMetadata && seasonalcategoryMetadata['Season'] ? seasonalcategoryMetadata['Season'].map(v => ({ value: v })) : []}
          placeholder='Season dropdown'
          onChange={next => {
            updateSeasonalCategoryfield('Season', next.map(v => v.value))
          }}
          multi={true}
          labelField='value'
          valueField='value'
          className="w-40"
          key={values.join('-')}
          options={[{ value: 'Spring Summer' }, { value: 'Autumn Winter' }]}
        />
      </div>

      <div className="w-96 px-4">
        Recommendation dropdown : <Select values={seasonalcategoryMetadata && seasonalcategoryMetadata['Recommendation'] ? seasonalcategoryMetadata['Recommendation'].map(v => ({ value: v })) : []}
          placeholder='Select Reccomendation'
          onChange={next => {
            updateSeasonalCategoryfield('Recommendation', next.map(v => v.value))
          }}
          multi={true}
          labelField='value'
          valueField='value'
          className="w-80"
          key={(seasonalcategoryMetadata && seasonalcategoryMetadata['Recommendation'] ? seasonalcategoryMetadata['Recommendation'].map(v => ({ value: v })) : []).join('-')}
          options={RecommendationDropdownValues.map(v => ({ value: v }))}
        />
      </div>

      <div className="w-96 px-4">
        Recommendation Argument dropdown : <Select values={seasonalcategoryMetadata && seasonalcategoryMetadata['Recommendation Argument'] ? seasonalcategoryMetadata['Recommendation Argument'].map(v => ({ value: v })) : []}
          placeholder='Select Reccomendation Argument'
          onChange={next => {
            updateSeasonalCategoryfield('Recommendation Argument', next.map(v => v.value))
          }}
          multi={true}
          labelField='value'
          valueField='value'
          className="w-80"
          key={values.join('-')}
          options={RecommendationArgumentDropdownValues.map(v => ({ value: v }))}
        />
      </div>
      <div className="w-96 px-4">
        Edgy vs. Comfort dropdown : <Select values={seasonalcategoryMetadata && seasonalcategoryMetadata['Edgy vs. Comfort'] ? seasonalcategoryMetadata['Edgy vs. Comfort'].map(v => ({ value: v })) : []}
          placeholder='Select Edgy vs. Comfort'
          onChange={next => {
            updateSeasonalCategoryfield('Edgy vs. Comfort', next.map(v => v.value))
          }}
          multi={true}
          labelField='value'
          valueField='value'
          className="w-80"
          key={values.join('-')}
          options={EdgynComfortOptions.map(v => ({ value: v }))}
        />
      </div>
      <div className="w-96 px-4">
        Recommendation Category : <Select values={seasonalcategoryMetadata && seasonalcategoryMetadata['Recommended Category'] ? [{ value: seasonalcategoryMetadata['Recommended Category'] }] : []}
          placeholder='Select Reccomended Category'
          onChange={next => {
            if (next.length == 0)
              return
            const newValue = next[next.length - 1].value
            updateSeasonalCategoryfield('Recommended Category', newValue)
          }}
          labelField='value'
          valueField='value'
          className="w-80"
          key={values.join('-')}
          options={metaCategories.map(v => ({ value: v }))}
        />

      </div>
      <div className="w-96 px-4">
        AI Image Category: <Select values={seasonalcategoryMetadata && seasonalcategoryMetadata['AiImageQuality'] ? [{ value: seasonalcategoryMetadata['AiImageQuality'] }] : [{ value: "Medium" }]}
          placeholder='Select Ai Image Quality'
          onChange={next => {
            if (next.length == 0)
              return
            const newValue = next[next.length - 1].value
            updateSeasonalCategoryfield('AiImageQuality', newValue)
          }}
          labelField='value'
          valueField='value'
          className="w-80"
          key={values.join('-')}
          options={AiImageQualityValues.map(v => ({ value: v }))}
        />

      </div>
    </div> : null}
  </>

}

export default AdditionalDataUpdate
